import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseModalDirective } from '../base-modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder } from '@angular/forms';

@Component({
    selector: 'nh-document-types',
    templateUrl: './document-types.component.html',
    styleUrls: ['./document-types.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class DocumentTypesComponent extends BaseModalDirective implements OnInit{

  constructor(
    protected modalRef: BsModalRef,
    protected builder: FormBuilder
  ) {
    super(modalRef, builder);
  }

  ngOnInit() {
    
  }

  getSupportingPaystubOverride(): string | null {
    const languageCode = sessionStorage.getItem('globalTranslatedLan')?.toLowerCase();

    if (languageCode === 'zh') {
      return '工资单';
    }
    if (languageCode === 'vi') {
      return 'Phiếu lương';
    }
    if (languageCode === 'tl') {
      return 'Resibo ng sahod';
    }

    if(languageCode === 'ar'){
      return 'كشف الراتب';
    }

    return null;
  }
}
